import Vue from 'vue'

export default {
  card: {
    getItem (slug) {
      return Vue.http.get(`api/cards/${slug}?with=previous-prices`)
    },
    updateItem (slug, data) {
      return Vue.http.put(`api/cards/${slug}`, data)
    },
    publish (id) {
      return Vue.http.get(`api/cards/${id}/publish`)
    }
  },
  record: {
    update (id, record) {
      return Vue.http.put(`api/records/${id}`, record)
    },
    get (id, success, error) {
      Vue.http.get(`api/records/${id}`).then(success, error)
    }
  },
  auth: {
    login (username, password) {
      return Vue.http.post('api/login_check', {
        _username: username,
        _password: password
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api.js